<template>
     <select class="w3-select" v-model="fieldModelValue">
        <option disabled value="">Please select ...</option>
        <option v-for="(business,index) in businessestemps"  :value="constructbusinesslink(business,index)" :key="index">{{business.name}}</option>           
     </select>
</template>

<script>
import {mapActions,mapGetters} from "vuex";
export default {
    props: ["value","type"],
     data: function() {
      return {        
        businessestemps:null
      }
    },
    computed: { 
      ...mapGetters(["business","alladminrights"]),
      fieldModelValue: {
            get() {
              return this.value;
            },
            set(newValue) {
              this.$emit('input', newValue);
            }
      }     
    },
    methods:{
      constructbusinesslink(business,id){
          return {...business,id}
      },
      getBusinessess(){
          if(this.type==='linked'){
            this.linkedbusiness({business:this.business}).then((businessslist)=>{                                   
              this.businessestemps = businessslist
            })
          }

          if(this.type==='lodge'){
            this.lodgewithbusinesses({business:this.business}).then((lodgebusinesses)=>{                                   
              this.businessestemps = lodgebusinesses
            })
          }

          if(this.type==='rights'){
            this.businessestemps = Object.keys(this.alladminrights).reduce((accum,key)=>{  
                accum[key] = this.alladminrights[key]                                 
                return accum
            },{})
          }
      },
      ...mapActions(['lodgewithbusinesses','linkedbusiness'])
    },
    created(){
        this.getBusinessess();
    }
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/BusinessesLinksList.vue